(function () {
  const root = document.getElementById('lesy-events-calendar');
  if (!root) return;

  const apiUrl = root.dataset.apiUrl;
  const mapsKey = root.dataset.mapsKey;
  let locale = (root.dataset.locale || 'fr').split('-')[0];
  if (!['fr', 'en', 'es'].includes(locale)) locale = 'fr';

  const MONTHS = {
    fr: ['JAN','FÉV','MARS','AVR','MAI','JUIN','JUIL','AOÛT','SEPT','OCT','NOV','DÉC'],
    en: ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'],
    es: ['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC'],
  };

  let allEvents = [];
  const state = { dates: null, type: null, lieu: null, hote: null };

  const FULL_MONTHS = {
    fr: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    es: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
  };
  const WEEKDAYS = {
    fr: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
    en: ['Su','Mo','Tu','We','Th','Fr','Sa'],
    es: ['Do','Lu','Ma','Mi','Ju','Vi','Sa'],
  };
  const CAL_LABELS = {
    today: { fr: "Aujourd'hui", en: 'Today', es: 'Hoy' },
    tomorrow: { fr: 'Demain', en: 'Tomorrow', es: 'Mañana' },
    nextWeek: { fr: 'Prochaine semaine', en: 'Next week', es: 'Próxima semana' },
    nextMonth: { fr: 'Prochain mois', en: 'Next month', es: 'Próximo mes' },
    clear: { fr: 'VIDER', en: 'CLEAR', es: 'BORRAR' },
  };

  let calViewDate = new Date(); // le calendrier de gauche affiche ce mois; celui de droite affiche le suivant
  let calPendingStart = null; // premier jour cliqué, en attente d'un second clic pour fermer la plage

  function stripTime(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function applyDatePreset(key) {
    const now = new Date();
    const today = stripTime(now);
    if (key === 'today') {
      state.dates = { start: today, end: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59) };
    } else if (key === 'tomorrow') {
      const t = new Date(today); t.setDate(t.getDate() + 1);
      state.dates = { start: t, end: new Date(t.getFullYear(), t.getMonth(), t.getDate(), 23, 59, 59) };
    } else if (key === 'nextWeek') {
      const start = new Date(today); start.setDate(start.getDate() + 1);
      const end = new Date(today); end.setDate(end.getDate() + 7); end.setHours(23, 59, 59, 999);
      state.dates = { start, end };
    } else if (key === 'nextMonth') {
      state.dates = {
        start: new Date(today.getFullYear(), today.getMonth() + 1, 1),
        end: new Date(today.getFullYear(), today.getMonth() + 2, 0, 23, 59, 59),
      };
    }
    calPendingStart = null;
  }

  function renderCalendarMonth(monthDate) {
    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const startOffset = firstDay.getDay(); // 0=dimanche
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const cellsStart = new Date(year, month, 1 - startOffset);

    let cells = '';
    for (let i = 0; i < 42; i++) {
      const cellDate = new Date(cellsStart);
      cellDate.setDate(cellsStart.getDate() + i);
      if (i >= 35 && cellDate.getMonth() !== month) break; // pas de 6e ligne inutile
      const outside = cellDate.getMonth() !== month;
      const inRange = state.dates && state.dates.start && state.dates.end &&
        cellDate >= stripTime(state.dates.start) && cellDate <= stripTime(state.dates.end);
      const isStart = state.dates && state.dates.start && stripTime(state.dates.start).getTime() === cellDate.getTime();
      const isEnd = state.dates && state.dates.end && stripTime(state.dates.end).getTime() === cellDate.getTime();
      const isPending = calPendingStart && stripTime(calPendingStart).getTime() === cellDate.getTime();
      const classes = ['lesy-cal__day'];
      if (outside) classes.push('lesy-cal__day--outside');
      if (inRange) classes.push('lesy-cal__day--inrange');
      if (isStart || isEnd || isPending) classes.push('lesy-cal__day--selected');
      cells += `<button type="button" class="${classes.join(' ')}" data-date="${cellDate.toISOString()}">${cellDate.getDate()}</button>`;
    }

    const weekdayRow = WEEKDAYS[locale].map(w => `<span class="lesy-cal__weekday">${w}</span>`).join('');

    return `
      <div class="lesy-cal__month-label">${FULL_MONTHS[locale][month]} ${year}</div>
      <div class="lesy-cal__grid">${weekdayRow}${cells}</div>
    `;
  }

  function buildDateMenu() {
    renderDateMenuContents();
  }

  const CAL_STATUS = {
    pickStart: { fr: 'Sélectionnez la date de début', en: 'Select the start date', es: 'Seleccione la fecha de inicio' },
    pickEnd: { fr: 'Sélectionnez la date de fin', en: 'Select the end date', es: 'Seleccione la fecha de fin' },
  };

  function calStatusText() {
    if (calPendingStart) return CAL_STATUS.pickEnd[locale];
    return CAL_STATUS.pickStart[locale];
  }

  function renderDateMenuContents() {
    const container = root.querySelector('.lesy-filter[data-filter="dates"] .lesy-filter__menu');
    const leftMonth = new Date(calViewDate.getFullYear(), calViewDate.getMonth(), 1);
    const rightMonth = new Date(calViewDate.getFullYear(), calViewDate.getMonth() + 1, 1);

    container.innerHTML = `
      <div class="lesy-cal">
        <div class="lesy-cal__presets">
          <button type="button" data-preset="today">${CAL_LABELS.today[locale]}</button>
          <button type="button" data-preset="tomorrow">${CAL_LABELS.tomorrow[locale]}</button>
          <button type="button" data-preset="nextWeek">${CAL_LABELS.nextWeek[locale]}</button>
          <button type="button" data-preset="nextMonth">${CAL_LABELS.nextMonth[locale]}</button>
        </div>
        <p class="lesy-cal__status">${calStatusText()}</p>
        <div class="lesy-cal__months">
          <div class="lesy-cal__month">
            <div class="lesy-cal__nav">
              <button type="button" class="lesy-cal__arrow" data-nav="prev">←</button>
              <span></span>
              <span></span>
            </div>
            ${renderCalendarMonth(leftMonth)}
          </div>
          <div class="lesy-cal__month">
            <div class="lesy-cal__nav">
              <span></span>
              <span></span>
              <button type="button" class="lesy-cal__arrow" data-nav="next">→</button>
            </div>
            ${renderCalendarMonth(rightMonth)}
          </div>
        </div>
        <button type="button" class="lesy-cal__clear">${CAL_LABELS.clear[locale]}</button>
      </div>
    `;

    if (!container.dataset.stopWired) {
      container.addEventListener('click', (e) => e.stopPropagation());
      container.dataset.stopWired = '1';
    }

    container.querySelectorAll('[data-preset]').forEach(btn => {
      btn.addEventListener('click', () => {
        applyDatePreset(btn.dataset.preset);
        render();
        closeMenus();
      });
    });

    container.querySelector('[data-nav="prev"]').addEventListener('click', () => {
      calViewDate.setMonth(calViewDate.getMonth() - 1);
      renderDateMenuContents();
    });
    container.querySelector('[data-nav="next"]').addEventListener('click', () => {
      calViewDate.setMonth(calViewDate.getMonth() + 1);
      renderDateMenuContents();
    });

    container.querySelectorAll('.lesy-cal__day').forEach(cell => {
      cell.addEventListener('click', () => {
        const clicked = new Date(cell.dataset.date);
        if (!calPendingStart) {
          calPendingStart = clicked;
          renderDateMenuContents();
        } else {
          let start = calPendingStart, end = clicked;
          if (end < start) { const tmp = start; start = end; end = tmp; }
          state.dates = { start: stripTime(start), end: new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59) };
          calPendingStart = null;
          render();
          closeMenus();
        }
      });

      cell.addEventListener('mouseenter', () => {
        if (!calPendingStart) return;
        const hovered = stripTime(new Date(cell.dataset.date));
        const start = stripTime(calPendingStart);
        const rangeMin = hovered < start ? hovered : start;
        const rangeMax = hovered < start ? start : hovered;
        container.querySelectorAll('.lesy-cal__day').forEach(other => {
          const otherDate = stripTime(new Date(other.dataset.date));
          const isBetween = otherDate > rangeMin && otherDate < rangeMax;
          other.classList.toggle('lesy-cal__day--preview', isBetween);
        });
      });
    });

    container.querySelector('.lesy-cal__months').addEventListener('mouseleave', () => {
      container.querySelectorAll('.lesy-cal__day--preview').forEach(el => el.classList.remove('lesy-cal__day--preview'));
    });

    container.querySelector('.lesy-cal__clear').addEventListener('click', () => {
      state.dates = null;
      calPendingStart = null;
      render();
      closeMenus();
    });
  }

  function applyStaticTranslations() {
    document.querySelectorAll('[data-fr]').forEach(el => {
      const val = el.getAttribute('data-' + locale);
      if (val) el.textContent = val;
    });
  }

  const TZ = 'America/Toronto';

  const ICON_PIN = '<svg width="14" height="14" viewBox="0 0 24 24" fill="#4B3F8F" style="vertical-align:-2px;margin-right:4px" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';
  const ICON_CLOCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4B3F8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:4px" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  function fmtBadgeDate(dateStr) {
    const d = new Date(dateStr);
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, month: 'numeric', day: 'numeric' }).formatToParts(d);
    const month = parseInt(parts.find(p => p.type === 'month').value, 10) - 1;
    const day = parseInt(parts.find(p => p.type === 'day').value, 10);
    return { month: MONTHS[locale][month], day };
  }

  function fmtRange(startStr, endStr, showYear) {
    const opts = { timeZone: TZ, month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };
    if (showYear) opts.year = 'numeric';
    const s = new Date(startStr), e = new Date(endStr);
    const localeTag = locale === 'fr' ? 'fr-CA' : locale === 'es' ? 'es-ES' : 'en-CA';
    return `${s.toLocaleString(localeTag, opts)} - ${e.toLocaleString(localeTag, opts)}`;
  }

  function eventTypeColorClass(type) {
    // couleur stable basée sur le texte du type
    let hash = 0;
    for (let i = 0; i < type.length; i++) hash = type.charCodeAt(i) + ((hash << 5) - hash);
    const palette = ['red', 'purple', 'teal', 'orange', 'blue'];
    return 'lesy-badge--' + palette[Math.abs(hash) % palette.length];
  }

  function renderFilters() {
    const uniques = (key) => [...new Set(allEvents.map(e => e[key]).filter(Boolean))];

    buildDateMenu();

    const menus = {
      type: uniques('type_evenement'),
      lieu: uniques('lieu_nom'),
      hote: uniques('hote'),
    };

    ['type', 'lieu', 'hote'].forEach(key => {
      const container = root.querySelector(`.lesy-filter[data-filter="${key}"] .lesy-filter__menu`);
      container.innerHTML = '';
      const allBtn = document.createElement('button');
      allBtn.textContent = locale === 'en' ? 'All' : locale === 'es' ? 'Todos' : 'Tous';
      allBtn.addEventListener('click', () => { state[key] = null; render(); closeMenus(); });
      container.appendChild(allBtn);
      menus[key].forEach(val => {
        const btn = document.createElement('button');
        btn.textContent = val;
        btn.addEventListener('click', () => { state[key] = val; render(); closeMenus(); });
        container.appendChild(btn);
      });
    });

    root.querySelectorAll('.lesy-filter__btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const menu = btn.nextElementSibling;
        const isOpen = menu.classList.contains('open');
        const filterEl = btn.closest('.lesy-filter');
        closeMenus();
        if (!isOpen) {
          if (filterEl.dataset.filter === 'dates' && state.dates && state.dates.start) {
            calViewDate = new Date(state.dates.start.getFullYear(), state.dates.start.getMonth(), 1);
            renderDateMenuContents();
          }
          menu.classList.add('open');
        }
      });
    });
  }

  function closeMenus() {
    root.querySelectorAll('.lesy-filter__menu').forEach(m => m.classList.remove('open'));
  }

  function passesFilters(ev) {
    if (state.type && ev.type_evenement !== state.type) return false;
    if (state.lieu && ev.lieu_nom !== state.lieu) return false;
    if (state.hote && ev.hote !== state.hote) return false;
    if (state.dates) {
      const evStart = new Date(ev.date_debut);
      const evEnd = new Date(ev.date_fin);
      if (state.dates.start && evEnd < state.dates.start) return false;
      if (state.dates.end && evStart > state.dates.end) return false;
    }
    return true;
  }

  function render() {
    const now = new Date();
    const filtered = allEvents.filter(passesFilters);
    const upcoming = filtered.filter(e => new Date(e.date_fin) >= now)
      .sort((a, b) => new Date(a.date_debut) - new Date(b.date_debut));
    const past = filtered.filter(e => new Date(e.date_fin) < now)
      .sort((a, b) => new Date(b.date_debut) - new Date(a.date_debut));

    renderList('upcoming', upcoming);
    renderList('past', past);
    root.querySelector('[data-list-heading="past"]').style.display = past.length ? '' : 'none';
  }

  function renderList(kind, events) {
    const container = root.querySelector(`[data-list="${kind}"]`);
    container.innerHTML = '';
    events.forEach(ev => {
      const badge = fmtBadgeDate(ev.date_debut);
      const badgeEnd = fmtBadgeDate(ev.date_fin);
      const isPast = kind === 'past';
      const yearLabel = isPast
        ? new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric' }).format(new Date(ev.date_debut))
        : '';
      const row = document.createElement('div');
      row.className = 'lesy-event-row';
      const dateHtml = badgeEnd.day !== badge.day
        ? `<span class="lesy-event-row__day lesy-event-row__day--start">${badge.month}<br><b>${badge.day}</b>${isPast ? `<small class="lesy-event-row__year">${yearLabel}</small>` : ''}</span>
           <span class="lesy-event-row__sep">-</span>
           <span class="lesy-event-row__day lesy-event-row__day--end">${badgeEnd.month}<br><b>${badgeEnd.day}</b></span>`
        : `<span class="lesy-event-row__day lesy-event-row__day--start">${badge.month}<br><b>${badge.day}</b>${isPast ? `<small class="lesy-event-row__year">${yearLabel}</small>` : ''}</span>`;

      row.innerHTML = `
        <span class="lesy-badge ${eventTypeColorClass(ev.type_evenement)}">${ev.type_evenement}</span>
        <div class="lesy-event-row__body">
          <div class="lesy-event-row__date">
            ${dateHtml}
          </div>
          <div class="lesy-event-row__info">
            <h4>${ev.titre}</h4>
            <div class="lesy-event-row__meta">
              <span>${ICON_CLOCK}${fmtRange(ev.date_debut, ev.date_fin, isPast)}</span>
              <span>${ICON_PIN}${ev.lieu_nom}</span>
            </div>
          </div>
        </div>
      `;
      row.addEventListener('click', () => openModal(ev));
      container.appendChild(row);
    });
  }

  const SHARE_LABELS = {
    copied: { fr: 'Copié !', en: 'Copied!', es: '¡Copiado!' },
    copyLink: { fr: 'Copier le lien', en: 'Copy link', es: 'Copiar enlace' },
    emailSubject: { fr: 'Invitation : ', en: 'Invitation: ', es: 'Invitación: ' },
  };

  function eventShareUrl(ev) {
    const url = new URL(window.location.href);
    url.searchParams.set('evenement', ev.id);
    return url.toString();
  }

  function wireShareButtons(ev) {
    const modal = document.getElementById('lesy-events-modal');
    const copyBtn = modal.querySelector('[data-share="copy"]');
    const emailBtn = modal.querySelector('[data-share="email"]');
    const shareUrl = eventShareUrl(ev);

    copyBtn.onclick = async () => {
      try {
        await navigator.clipboard.writeText(shareUrl);
      } catch (e) {
        const temp = document.createElement('textarea');
        temp.value = shareUrl;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);
      }
      const label = copyBtn.querySelector('span');
      const original = label.textContent;
      label.textContent = SHARE_LABELS.copied[locale];
      setTimeout(() => { label.textContent = original; }, 2000);
    };

    const subject = encodeURIComponent(SHARE_LABELS.emailSubject[locale] + ev.titre);
    const body = encodeURIComponent(
      `${ev.titre}\n${fmtRange(ev.date_debut, ev.date_fin)}\n${ev.lieu_nom} - ${ev.adresse}\n\n${shareUrl}`
    );
    emailBtn.href = `mailto:?subject=${subject}&body=${body}`;
  }

  function openModal(ev) {
    const modal = document.getElementById('lesy-events-modal');
    modal.querySelector('.lesy-events-modal__eyebrow').textContent = ev.type_evenement;
    modal.querySelector('.lesy-events-modal__title').textContent = ev.titre;
    const descEl = modal.querySelector('.lesy-events-modal__description');
    descEl.textContent = ev.description || '';
    descEl.style.display = ev.description ? '' : 'none';
    modal.querySelector('.lesy-events-modal__when').textContent = fmtRange(ev.date_debut, ev.date_fin);
    modal.querySelector('.lesy-events-modal__where').innerHTML = `${ev.lieu_nom}<br>${ev.adresse}`;
    modal.querySelector('.lesy-events-modal__directions').href =
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ev.adresse)}`;

    const addCalLink = modal.querySelector('.lesy-events-modal__add-cal');
    addCalLink.href = ev.lien_ajout_calendrier || googleCalendarLink(ev);

    const mapDiv = modal.querySelector('.lesy-events-modal__map');
    mapDiv.innerHTML = mapsKey
      ? `<iframe width="100%" height="320" frameborder="0" style="border:0" loading="lazy" allowfullscreen
          src="https://www.google.com/maps/embed/v1/place?key=${mapsKey}&q=${encodeURIComponent(ev.adresse)}"></iframe>`
      : `<a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ev.adresse)}" target="_blank" rel="noopener">${locale === 'en' ? 'View on Google Maps' : locale === 'es' ? 'Ver en Google Maps' : 'Voir sur Google Maps'}</a>`;

    modal.hidden = false;
    wireShareButtons(ev);
  }

  function googleCalendarLink(ev) {
    const fmt = (d) => new Date(d).toISOString().replace(/[-:]|\.\d{3}/g, '');
    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(ev.titre)}&dates=${fmt(ev.date_debut)}/${fmt(ev.date_fin)}&location=${encodeURIComponent(ev.adresse)}&details=${encodeURIComponent(ev.description || '')}`;
  }

  document.getElementById('lesy-events-modal').addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-close')) {
      document.getElementById('lesy-events-modal').hidden = true;
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.lesy-filter')) closeMenus();
  });

  async function init() {
    applyStaticTranslations();
    try {
      const res = await fetch(`${apiUrl}?lang=${locale}`);
      const data = await res.json();
      allEvents = data.events || [];
      root.querySelector('.lesy-events__loading').style.display = 'none';
      renderFilters();
      render();

      const sharedId = new URLSearchParams(window.location.search).get('evenement');
      if (sharedId) {
        const shared = allEvents.find(e => String(e.id) === String(sharedId));
        if (shared) openModal(shared);
      }
    } catch (err) {
      root.querySelector('.lesy-events__loading').textContent =
        locale === 'en' ? 'Unable to load events.' : locale === 'es' ? 'No se pudieron cargar los eventos.' : 'Impossible de charger les événements.';
      console.error('Lesy events error:', err);
    }
  }

  init();
})();